/**
 * ThriveScore account completion models for CORE-321
 * Handles promotion from ThriveScoreProvisional (2) to ThriveScoreComplete (3)
 */

export enum AccountSourceEnum {
  General = 1,
  ThriveScoreProvisional = 2,
  ThriveScoreComplete = 3,
  Mobile = 4,
  Store = 5,
  Admin = 6,
}

export interface CompleteAccountRequest {
  lastName: string;
  phone: string;
  /** ISO 8601 date string (stored as string to keep Redux state serializable) */
  dateOfBirth: string;
  password?: string;
}

export interface AccountCompletionStatus {
  accountId: number;
  accountSourceId: number;
  isProvisional: boolean;
  completionPercentage?: number;
}

/** Response from POST /thrivescore/auth/otp/verify */
export interface OtpVerifyResponse {
  token: string;
  userId: number;
  email: string;
  firstName?: string;
  lastName?: string;
}
